import config from '../../../config/config.json';

export const CONTEXT_ROOT = config.express.mountpath;
export const COMPONENT = 'developerstudionodeweb';
export const SPACE_KEY = 'SKEXJE';
export const TENANT_NAME = 'paypal';
export const FPTI_CONSTANTS = {
  EVENT_PREFIX: 'devexp',
  BUTTON: 'button',
  LINK: 'link',
  TAB: 'tab',
  ELEMENT: 'element',
  MODAL: 'modal',
  FIELD: 'field',
  PAGE: 'page',
  KEYBOARD: 'keyboard'
};
export const FPTI_ACTION = {
  PRESSED: 'pressed',
  SHOWN: 'shown',
  ERROR: 'error',
  FOCUS: 'focus',
  BLUR: 'exit',
  CHANGED: 'changed',
  CLOSED: 'closed',
  COPY: 'copy'
};

export const PAGE_NAMES = {
  GET_STARTED: 'get_started'
};

export const FIELD_NAMES = {
  COUNTRY_SELECTOR: 'Country or region'
};

// Account Types
export const BUSINESS = 'BUSINESS';
export const INDIVIDUAL = 'INDIVIDUAL';

export const LIVE_BASE_URL = 'https://www.paypal.com';
export const STAGE_BASE_URL = 'https://msmaster.qa.paypal.com';
export const STUDIO_API_PREFIX = '/studio/api/v1';

export const PARTNER = 'partner';
export const DIRECT = 'direct';
